module.exports = __webpack_public_path__ + "img/columns-01.bc942764.svg";